export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const scrollToTopSticky = (contentRef: React.RefObject<HTMLDivElement>) => {
  // For sticky elements, we have to scroll the body and the element itself to the top
  window.scrollTo({ top: 0, behavior: 'smooth' });
  contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
};
